import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useRefundChargebackReportFilterFields } from './hooks/useRefundChargebackReportFilterFields';

export const RefundChargebackReportFilterChips: React.FC = () => {
  const fields = useRefundChargebackReportFilterFields();

  return <FilterChips fields={fields} />;
};
